import {translations} from 'presentation/translations-new';
import {ChoseRightAlertMessageVariableProps} from './types';

const {
	alert: {emailVariable, cellphoneVariable},
} = translations['pt-br'].privateFlow.bookingFlow.confirmationDrawer;

const chooseRightAlertMessageVariable = ({
	isInvalidPhone,
	isInvalidEmail,
}: ChoseRightAlertMessageVariableProps) => {
	if (isInvalidPhone) {
		return cellphoneVariable;
	}
	if (isInvalidEmail) {
		return emailVariable;
	}
	return '';
};

export {chooseRightAlertMessageVariable};
